Postlogin = ((postlogin) => {
    postlogin.LessonGroupSelection = {};
    const self = postlogin.LessonGroupSelection;
    const studentSelections = [];
    const studentsTable = $('#students-table');
    const groupsTable = $('#groups-table');
    const selectedStudentList = $('#selected-students-list');
    const createAssignmentBtn = $('#create-update-assignment');
    const filterLicense = $('#filter-license');
    const filterGrade = $('#filter-grade');
    const tableHeight = window.innerHeight * 0.65;
    let isConfirmStudentRemove = false;
    const confirmStudentRemoveMessage = 'This will remove the student(s) from the assignment and delete any progress they have made against the lesson. Are you sure you want to remove the student(s) from this assignment?';
    const currentUrl = window.location.href;

    const init = () => {
        initTables();
        initEvents();
        initDates();
    };

    const initDates = () => {
        const today = new Date();

        const dateOptions = {
            display: {
                theme: 'light',
                components: {
                    clock: false,
                },
            },
            localization: {
                format: 'L',
            },
            restrictions: {
                minDate: today,
            },
        };

        const startDateInput = document.getElementById('date_start');
        const startDatePicker = new tempusDominus.TempusDominus(document.getElementById('date_start'), {
            ...dateOptions,
            container: document.getElementById('start-date-container'),
        });

        if (startDateInput.value) {
            // Our date comes in as YYYY/MM/DD, JS will always parse this as a day off, so we adjust using date math.
            const savedDate = new Date(startDateInput.value);
            const adjustedDate = new Date(savedDate.setDate(savedDate.getDate() + 1));
            startDatePicker.dates.setValue(startDatePicker.dates.parseInput(adjustedDate.toLocaleDateString('en-US')));
        } else {
            startDatePicker.dates.setValue(startDatePicker.dates.parseInput(today));
        }
    };

    const initEvents = () => {
        selectedStudentList.closest('form').on('submit', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const action = selectedStudentList.closest('form').attr('action');
            const assignmentData = selectedStudentList.closest('form').serializeArray();
            assignmentData.push({
                name: 'student_selections',
                value: JSON.stringify(studentSelections),
            });
            createForm(action, assignmentData);
        });

        filterLicense.on('change', () => {
            studentsTable.bootstrapTable('refresh');
        });

        filterGrade.on('change', () => {
            studentsTable.bootstrapTable('refresh');
        });

        $('#completion_type').on('change', () => {
            if ($('#completion_type').val() === 'teacher') {
                initDates();

                $('#start-date-container').hide();
                $('#date_start').prop('disabled', true);
            } else {
                $('#start-date-container').show();
                $('#date_start').prop('disabled', false);
            }
        });

        $('#assign-to-all-modal-open').on('click', (e) => {
            e.preventDefault();
            const numUsers = studentsTable.bootstrapTable('getOptions').totalRows.toLocaleString();
            const modalBody = $('.modal-body');
            modalBody.append(`<span>Are you sure you want to assign the selected lessons to ${numUsers} students?</span>`);
        });

        $('#assign-to-all-confirm').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const action = '/lessons/bulk-assign/with-filters/';
            const assignmentData = selectedStudentList.closest('form').serializeArray();
            assignmentData.push({
                name: 'license',
                value: filterLicense.val(),
            });
            assignmentData.push({
                name: 'grade',
                value: filterGrade.val(),
            });
            assignmentData.push({
                name: 'search_term',
                value: $('#students .search-input').val(),
            });
            createForm(action, assignmentData);
        });
    };

    const initTables = () => {
        studentsTable.bootstrapTable({
            formatNoMatches() {
                return 'No students to show';
            },
            onCheck(row) {
                addStudent(row);
            },
            onUncheck(row) {
                if (currentUrl.indexOf('add') >= 0 || currentUrl.indexOf('bulk-assign') >= 0) {
                    removeStudent(row.user_id);
                    return;
                }

                if (isConfirmStudentRemove || window.confirm(confirmStudentRemoveMessage)) {
                    removeStudent(row.user_id);
                } else {
                    studentsTable.bootstrapTable('checkBy', {
                        field: 'user_id',
                        values: [row.user_id],
                    });
                }
            },
            onCheckAll(rows) {
                showAjaxProgressIndicator(() => {
                    for (let i = 0; i < rows.length; i += 1) {
                        if (!rows[i].disabled) {
                            addStudent(rows[i]);
                        }
                    }
                });
            },
            onUncheckAll(rowsAfter, rowsBefore) {
                // this event has two parameters only the second contains the items to be unchecked.
                if (currentUrl.indexOf('edit') >= 0 && !window.confirm(confirmStudentRemoveMessage)) {
                    return;
                } 

                showAjaxProgressIndicator(() => {
                    for (let i = 0; i < rowsBefore.length; i += 1) {
                        if (!rowsBefore[i].disabled) {
                            removeStudent(rowsBefore[i].user_id);
                        }
                    }
                });
            },
            height: tableHeight,
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            idField: 'user_id',
            minimumCountColumns: '2',
            search: true,
            sortName: 'last_name',
            sortOrder: 'asc',
            clickToSelect: true,
            maintainSelected: true,
            showPaginationSwitch: false,
            pagination: true,
            sidePagination: 'server',
            pageSize: 25,
            pageList: [10, 25, 50, 100, 500, 1000],
            rowAttributes(row) {
                return {
                    'data-user-id': row.user_id,
                };
            },
            url: '/users/list-with-disabled/',
            queryParamsType: 'other',
            queryParams(params) {
                const queryParams = {};

                queryParams.search_term = params.searchText;
                queryParams.page = params.pageNumber;
                queryParams.page_size = params.pageSize;
                queryParams.order_by = params.sortName;
                queryParams.sort_order = params.sortOrder;
                queryParams.user_type = [2];
                queryParams.hide_disabled = true;

                queryParams.active = 1;
                queryParams.license = filterLicense.val();
                queryParams.grade = filterGrade.val();

                return queryParams;
            },

            columns: [
                {
                    // sr-only header text so bootstrap-table's
                    // select-all <th> isn't announced as an empty
                    // header by screen readers (axe empty-table-header).
                    // The visual select-all checkbox is still drawn
                    // inside the <th> by bootstrap-table.
                    title: '<span class="sr-only">Select row</span>',
                    field: 'checkbox',
                    align: 'center',
                    valign: 'middle',
                    checkbox: true,
                },
                {
                    title: 'User ID',
                    field: 'user_id',
                    visible: false,
                },
                {
                    title: 'Username',
                    field: 'username',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'First Name',
                    field: 'first_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Last Name',
                    field: 'last_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Grade',
                    field: 'grade',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter: (row) => {
                        if (parseInt(row, 10) === 0) {
                            return 'K';
                        }
                        if (parseInt(row, 10) === -1) {
                            return 'PK';
                        }
                        return row;
                    },
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                return formattedResult;
            },
            onLoadSuccess() {
                if (!processedPreselectedStudents) {
                    loadPreselectedStudents();
                    processedPreselectedStudents = true;
                }

                $(studentSelections).each((i, userId) => {
                    studentsTable.bootstrapTable('checkBy', {
                        field: 'user_id',
                        values: [userId],
                    });
                });
            },
            rowStyle(row) {
                let classes = '';

                if (row.logged_in === 1) {
                    classes += 'success ';
                }

                if (row.disabled) {
                    classes += 'disabled';
                }

                return {
                    classes,
                };
            },
        });

        groupsTable.bootstrapTable({
            formatNoMatches() {
                return 'No groups to show';
            },
            onCheck(row) {
                if (!dontAdd) {
                    addGroup(row);
                }
            },
            checkboxHeader: false, // remove the check all option for groups - unchecking can't uncheck everyone in the group
            height: tableHeight,
            method: 'post',
            contentType: 'application/x-www-form-urlencoded',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            detailView: false,
            detailFormatter: groupDetailFormatter,
            showColumns: false,
            idField: 'group_id',
            minimumCountColumns: '2',
            search: true,
            sortName: 'shared',
            sortOrder: 'asc',
            clickToSelect: true,
            maintainSelected: true,
            showPaginationSwitch: false,
            pagination: true,
            sidePagination: 'server',
            pageSize: 25,
            url: '/groups/with-users/',
            columns: [
                {
                    // sr-only header text so bootstrap-table's
                    // select-all <th> isn't announced as an empty
                    // header by screen readers (axe empty-table-header).
                    // The visual select-all checkbox is still drawn
                    // inside the <th> by bootstrap-table.
                    title: '<span class="sr-only">Select row</span>',
                    field: 'checkbox',
                    align: 'center',
                    valign: 'middle',
                    checkbox: true,
                },
                {
                    title: 'Group ID',
                    field: 'group_id',
                    visible: false,
                },
                {
                    title: 'Name',
                    field: 'name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        const owner = `${row.first_name} ${row.last_name}`.trim();

                        if (row.shared) {
                            return `<em>${value} <small>(${owner})</small></em>`;
                        }

                        return value;
                    },
                },
                {
                    title: 'Owner',
                    field: 'last_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    formatter(value, row) {
                        return `${row.first_name} ${row.last_name}`.trim();
                    },
                },
                {
                    title: '# of Members',
                    field: 'users_count',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
            ],
            queryParamsType: '',
            queryParams(params) {
                const queryParams = { ...params };
                queryParams.ignore_empty = true;
                return queryParams;
            },
            responseHandler(res) {
                return {
                    total: res.meta.total,
                    rows: res.data,
                };
            },
        });

        const showAjaxProgressIndicator = (callback) => {
            const $ajaxProgressIndicator = $('#ajax-progress-indicator');
            $ajaxProgressIndicator.fadeIn();
            $ajaxProgressIndicator.promise().done(() => {
                callback();
                $ajaxProgressIndicator.fadeOut();
            });
        };

        selectedStudentList.on('click', '.remove-student', (e) => {
            const item = $(e.target).parent().parent();
            const userId = item.data('user-id');

            if (currentUrl.indexOf('add') >= 0 || currentUrl.indexOf('bulk-assign') >= 0) {
                removeStudent(userId);
                item.remove();
                return;
            }
            if (isConfirmStudentRemove || window.confirm(confirmStudentRemoveMessage)) {
                removeStudent(userId);
                item.remove();
            }
        });

        $('#clear-student-selection').on('click', (e) => {
            if (currentUrl.indexOf('edit') >= 0 && !window.confirm(confirmStudentRemoveMessage)) {
                return;
            }

            e.preventDefault();
            showAjaxProgressIndicator(() => {
                const studentSelectionsToRemove = studentSelections.slice();
                $.each(studentSelectionsToRemove, (i, userId) => {
                    removeStudent(userId);
                });
                updateGroupsTable();
            });
        });

        $('a[aria-controls="students"]').on('shown.bs.tab', () => {
            studentsTable.bootstrapTable('resetView');
        });
        $('a[aria-controls="groups"]').on('shown.bs.tab', () => {
            groupsTable.bootstrapTable('resetView');
        });

        $('#selected-students-list').css('height', `${tableHeight + 17}px`);
    };

    let dontAdd = false;
    let processedPreselectedStudents = false;

    const createForm = (action, assignmentData) => {
        const form = document.createElement('form');
        form.hidden = true;

        form.method = 'POST';
        form.action = action;

        const completionTypes = [];
        const subtitles = [];

        assignmentData.forEach((item) => {
            if (item.name !== 'btSelectItem' && !item.name.includes('subtitle[') && !item.name.includes('completion_type[')) {
                const element = document.createElement('input');
                element.value = item.value;
                element.name = item.name;

                form.appendChild(element);
            } else if (item.name.includes('subtitle[')) {
                subtitles[item.name.replace(/\D/g, '')] = item.value;
            } else if (item.name.includes('completion_type[')) {
                completionTypes[item.name.replace(/\D/g, '')] = item.value;
            }
        });

        const lessonsTable = $('#lessons-table');

        if (lessonsTable.get(0)) {
            const selectedLessons = lessonsTable.bootstrapTable('getSelections').map((d) => ({
                lesson_id: d.lesson_id,
                subtitle: subtitles[d.lesson_id],
                completion_type: completionTypes[d.lesson_id],
            }));

            const element = document.createElement('input');
            element.value = JSON.stringify(selectedLessons);
            element.name = 'lessons';

            form.appendChild(element);
        }
        document.body.appendChild(form);

        form.submit();
    };

    /**
     * Displays the list of students in this group
     */
    const groupDetailFormatter = (index, row) => {
        // create the list of students in this group...
        const html = [];
        html.push('<ul class="list-unstyled">');
        $.ajax({
            method: 'post',
            url: `/groups/${row.group_id}}/json/`,
            beforeSend() {
                $('#ajax-progress-indicator').fadeIn();
            },
            complete() {
                $('#ajax-progress-indicator').fadeOut();
            },
            success(data) {
                $.each(data.data, (studentId, student) => {
                    let selected = true;
                    if ($.inArray(parseInt(studentId, 10), studentSelections) === -1) {
                        selected = false;
                    }

                    const studentName = `${student.first_name} ${student.last_name}`.trim();
                    const details = `
                        <li class="pull-right">
                            <span data-student-id="${student.user_id}" id="group-student-${student.user_id}"
                                class="group-student btn btn-default btn-sm ${selected ? 'btn-primary' : ''}">
                                ${studentName}
                            </span>
                        </li>
                    `;

                    html.push(details);
                });
            },
            async: false,
        });
        html.push('</ul>');

        return html.join('');
    };

    const createStudentItem = (student) => {
        const studentFirstAndLastNames = [];
        let studentName = '-';

        if (student.first_name !== null) {
            studentFirstAndLastNames.push(student.first_name.trim());
        }
        if (student.last_name !== null) {
            studentFirstAndLastNames.push(student.last_name.trim());
        }

        if (studentFirstAndLastNames.length > 0) {
            studentName = studentFirstAndLastNames.join(' ');
        }

        return `
            <li class="list-item" id="student-${student.user_id}" data-user-id="${student.user_id}">
                <div class="list-content">
                    <i class="fa fa-times-circle remove-student" aria-hidden="true"></i>
                    <div class="student-container">
                        <div class="avatar">
                            <figure>
                                <img src="${student.avatar_image_path}" alt=" Avatar" class="img-responsive" />
                            </figure>
                        </div> <!-- /.avatar -->
                        <div class="name">
                            <span class="student-name">${studentName} (<span class="student-username">${student.username}</span>)</span><br>
                        </div> <!-- /.name -->
                    </div> <!-- /.student-container -->
                </div> <!-- /.list-content -->
            </li>
        `;
    };

    const addStudent = (student) => {
        // if this student isn't already in studentSelections list...
        if (studentSelections.indexOf(student.user_id) === -1) {
            // add this student to the studentSelections list...
            studentSelections.push(student.user_id);
            if (student.avatar_image_path == null) {
                // eslint-disable-next-line no-param-reassign
                student.avatar_image_path = '/images/avatars/default.png';
            }
            // create the student element html...
            const studentItem = createStudentItem(student);

            // add element to the selection list...
            selectedStudentList.prepend(studentItem);

            // mark that student as selected in the group students view
            $(`#group-student-${student.user_id}`).addClass('btn-primary');
        }

        $('.selected_count').html(studentSelections.length);
        if (studentSelections.length > 0) {
            $('#clear-student-selection').show();
        } else {
            $('#clear-student-selection').hide();
        }

        toggleCreateAssignmentButton();
    };

    const removeStudent = (userId) => {
        const id = parseInt(userId, 10);
        // if student IS in the studentSelections list...
        if (studentSelections.indexOf(id) !== -1) {
            // remove them from this list
            const index = studentSelections.indexOf(id);
            studentSelections.splice(index, 1);

            isConfirmStudentRemove = true;
            // remove them from the selections list
            selectedStudentList.find(`.list-item#student-${id}`).remove();

            // uncheck that row in the students table
            studentsTable.bootstrapTable('uncheckBy', {
                field: 'user_id',
                values: [id],
            });

            // mark that student as not selected in group students detailView
            $(`#group-student-${id}`).removeClass('btn-primary');
        }
        $('.selected_count').html(studentSelections.length);
        if (studentSelections.length > 0) {
            $('#clear-student-selection').show();
        } else {
            $('#clear-student-selection').hide();
        }

        toggleCreateAssignmentButton();
        isConfirmStudentRemove = false;
    };

    const groupRequestId = {};

    const addGroup = function (group) {
        groupRequestId[group.group_id] = (groupRequestId[group.group_id] || 0) + 1;
        const requestId = groupRequestId[group.group_id];

        $.ajax({
            method: 'post',
            url: `/groups/${group.group_id}/same-license-users/`,
            beforeSend() {
                $('#ajax-progress-indicator').fadeIn();
            },
            complete() {
                $('#ajax-progress-indicator').fadeOut();
            },
            success(data) {
                $.each(data.data, (key, value) => {
                    if (+value.role_id === 2) {
                        addStudent(value);
                    }
                });
            },
            error() {
                // If a newer request for this same group has been issued since,
                // this failure is stale -- don't undo the newer request's result.
                if (groupRequestId[group.group_id] !== requestId) {
                    return;
                }
                window.alert('Could not load students for this group. Please try again.');
                // No students were added for this group, so leaving it checked
                // would let the group be submitted without its members.
                groupsTable.bootstrapTable('uncheckBy', {
                    field: 'group_id',
                    values: [group.group_id],
                });
            },
        });
    };

    const toggleCreateAssignmentButton = () => {
        if (studentSelections.length <= 0) {
            selectedStudentList.find('.none-selected').show();
            createAssignmentBtn.prop('disabled', true);
        } else {
            selectedStudentList.find('.none-selected').hide();
            createAssignmentBtn.prop('disabled', false);
        }
    };

    const updateGroupsTable = () => {
        toggleCreateAssignmentButton();

        dontAdd = true;

        // go through each group, and if not all students in that group are checked, uncheck that group
        const groupData = groupsTable.bootstrapTable('getData');
        $.each(groupData, (key, group) => {
            const groupId = group.group_id;
            let checkIt = true;
            if (group.student_ids) {
                const studentIds = group.student_ids.replace(/ /g, '').split(',');
                $.each(studentIds, (i, studentId) => {
                    if ($.inArray(parseInt(studentId, 10), studentSelections) === -1) {
                        checkIt = false;
                    }
                });
            } else {
                checkIt = false;
            }

            groupsTable.bootstrapTable(checkIt ? 'checkBy' : 'uncheckBy', {
                field: 'group_id',
                values: [groupId],
            });
        });

        dontAdd = false;
    };

    const loadPreselectedStudents = () => {
        // TODO: update so students are added to the list that are already prexisting, but cannot be removed due to lack of access.
        const preselectedStudents = studentsTable.data('preselected-ids');
        $(preselectedStudents).each((i, student) => {
            addStudent(student);
        });
    };

    self.init = init;

    return postlogin;
})(Postlogin || {});
